import { render, staticRenderFns } from "./ContactModuleRulesRuleUpdated.vue?vue&type=template&id=0894be7c&scoped=true"
import script from "./ContactModuleRulesRuleUpdated.vue?vue&type=script&lang=js"
export * from "./ContactModuleRulesRuleUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894be7c",
  null
  
)

export default component.exports